// shared/hooks/useTravelPostQuoteData.ts

import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { useMemo } from "react";

export function useTravelPostQuoteData() {
  const {
    travelQuote: { travelDetails },
  } = usePosterReducers();

  const isInbound = useMemo(() => {
    return travelDetails?.coverage === "1" && travelDetails?.coverageLabel === "UAE Inbound";
  }, [travelDetails?.coverage, travelDetails?.coverageLabel]);

  return {
    travelDetails,
    isInbound,
  };
}
